var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AuthenticationReason, AuthenticationResult, AuthenticationStatus, VerificationType } from '@mc-alberta/types';
import { Adapter } from '../Adapter';
import { VERIFICATION_METHOD, VERIFICATION_RESULT } from '../../constants';
import { AuthenticationStrategy } from '../../types/enums/AuthenticationStrategy';
import { KpiOperation } from '../../types/enums/KpiOperation';
import axios, { isAxiosError } from 'axios';
import { HttpHeader } from '../../types/enums/http-header.enum';
import { ConsumerVerificationEntity } from '../../types/enums/consumer-subject.enum';
/**
 * Card security code (aka CVC, CVC2) validation.
 */
export class CscValidationAdapter extends Adapter {
    constructor() {
        super(...arguments);
        this.strategy = AuthenticationStrategy.CSC_VALIDATION;
        this.verificationMethods = [VERIFICATION_METHOD.CSC_VALIDATION];
        this.supportedReasons = [AuthenticationReason.CARD_VERIFICATION];
        this.selectedMethodIndex = 0;
        /** The card security code to validate. */
        this.csc = '';
        this.setMethodAttributes = () => { };
    }
    preloadSession() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getSession();
        });
    }
    initializeSession(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.kpi.start(KpiOperation.INITIATE_AUTHENTICATION);
            this.authorization = params.authorization;
            this.authenticationStatus = AuthenticationStatus.PENDING_CHALLENGE;
            return this.getSession();
        });
    }
    provideChallenge(csc) {
        this.kpi.start(KpiOperation.PROVIDE_AUTHENTICATION_CHALLENGE);
        this.csc = csc;
        this.authenticationStatus = AuthenticationStatus.PENDING;
        return this.getSession();
    }
    validateSession() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.kpi.start(KpiOperation.COMPLETE_AUTHENTICATION);
            try {
                const { data } = yield axios.post(`/api/cards/${this.accountReference.srcDigitalCardId}/validation`, {
                    validationData: this.csc,
                    programId: this.serviceId
                }, {
                    headers: {
                        [HttpHeader.AUTHORIZATION]: `Bearer ${this.authorization}`,
                        [HttpHeader.X_SRC_TRACE_ID]: this.traceId,
                        [HttpHeader.SRCI_TRANSACTION_ID]: this.srciTransactionId,
                        [HttpHeader.SRC_RECIPIENT_KEY_ID]: this.srcClientId,
                        [HttpHeader.SRC_DSA_ID]: this.srcDpaId,
                        [HttpHeader.SRC_CORRELATION_ID]: this.srcCorrelationId,
                        [HttpHeader.SRC_CLIENT_ID]: this.srcClientId
                    }
                });
                this.assuranceData = {
                    verificationData: [
                        {
                            verificationEntity: ConsumerVerificationEntity.SRC_SYSTEM,
                            verificationMethod: VERIFICATION_METHOD.CSC_VALIDATION,
                            verificationResults: VERIFICATION_RESULT.VERIFIED,
                            verificationTimestamp: Date.now().toString(),
                            verificationType: VerificationType.CARD,
                            additionalData: data.authorization
                        }
                    ]
                };
                this.authenticationStatus = AuthenticationStatus.COMPLETE;
                this.authenticationResult = AuthenticationResult.AUTHENTICATED;
            }
            catch (error) {
                if (isAxiosError(error) && ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data.status) === 'INVALID_STATE') {
                    // user failed the CVC challenge but can try again
                    this.authenticationStatus = AuthenticationStatus.PENDING_CHALLENGE;
                }
                else {
                    // any other failure is considered fatal
                    return this.destroySession(error);
                }
            }
            return this.getSession();
        });
    }
}
